/** @format */

import { IConditionalRouteProps } from "./ConditionalRoute.types";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Outlet } from "react-router";

const ConditionalRouteView: React.FC<IConditionalRouteProps> = ({
	doRedirect,
	redirectPathname,
	children,
}) => {
	const navigate = useNavigate();

	React.useEffect(() => {
		if (doRedirect) {
			navigate(redirectPathname);
		}
	}, [doRedirect, navigate, redirectPathname]);

	return (
		<>
			{doRedirect ? null : children}
			<Outlet />
		</>
	);
};

export default ConditionalRouteView;
